/**
 *
 * @param proficiencyBonus
 * @param abilityKeyLookup
 * @param abilityLookup
 * @param xpInfo
 * @param hitPointInfo
 * @param speedInfo
 * @param ruleData
 */
export function generateSnippetData(proficiencyBonus, abilityKeyLookup, abilityLookup, xpInfo, hitPointInfo, speedInfo, ruleData) {
    return {
        proficiencyBonus,
        abilityKeyLookup,
        abilityLookup,
        xpInfo,
        hitPointInfo,
        speedInfo,
        ruleData,
    };
}
